import React, { useEffect, useRef } from 'react';
import { VStack } from '@adc/parallax-component-library';
import { MAIN_SIZE } from 'Reducers/scrollPage/types';
import { store } from 'Utilities/store';
const Main = ({ px, ...rest }) => {
    const mainRef = useRef();
    useEffect(() => {
        if (store && mainRef.current) {
            store.dispatch({ type: MAIN_SIZE, mainSize: mainRef.current.clientHeight });
        }
    }, [mainRef]);
    return (React.createElement(VStack, { ref: mainRef, paddingHorizontal: px, background: "$surface.background", style: [{ minHeight: window.innerHeight, height: '100vh' }], ...rest }));
};
export { Main };
